<template>
    <div class="hypothec-calculator">
        <!-- {{price}} -->
        <!-- {{initPrice}} -->
        <!-- Сделать функцию автоматической подмены максимального значения в полях -> input keyup -->
        <div class="banks-items-crousel">
            <div class="bank-btn-prev slider-btn">
                <svgIcon name="left-arrow" class="icon-left-arrow"/>
            </div>
            <swiper :options="swiperOption" ref="promoCarousel">
                <swiper-slide v-for="(slide, index) in calculatorPage.calculator_banks_params" :key="index">
                    <a href="#" @click.prevent="setBankParams(slide)" :class="{'active' : currentBankSetup.bank == slide.bank_name}">
                        <strong>{{ slide.bank_name }}</strong>
                    </a>
                </swiper-slide>
            </swiper>
            <div class="bank-btn-next slider-btn">
                <svgIcon name="right-arrow" class="icon-right-arrow"/>
            </div>
        </div>
        <div class="column-container">
            <div class="col-left">
                <div class="calculator-items">
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.calculator_syntax.filter_price}}</label>
                            <!-- <input type="number" name="price"  class="form-control" v-model="price" @keyup="keymonitor"> -->
                            <!-- @value="toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')" -->
                            <input type="number" name="price"  class="form-control" v-model="price" @keyup="keymonitor">
                            <!-- @keyup="keymonitor" -->
                            <svgIcon name="tenge" class="icon-tenge"/>
                        </div>
                        <div class="calculator-slider" v-if="!hideSlider">
                            <vue-slider v-model="price" :min="minPrice" :max="maxPrice" :interval="intervalPrice" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.calculator_syntax.filter_initprice}} {{pricePercent + '%'}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="initPrice" @keyup="keymonitor">
                            <svgIcon name="tenge" class="icon-tenge"/>
                        </div>
                        <div class="calculator-slider" v-if="!hideSlider">
                            <vue-slider v-model="initPrice" :min="minInitPrice" :max="maxInitPrice" :interval="intervalPrice" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.calculator_syntax.filter_rate}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="curRate" @keyup="keymonitor">
                            <svgIcon name="precent" class="icon-precent"/>
                        </div>
                        <div class="calculator-slider" v-if="!hideSlider">
                            <vue-slider v-model="curRate" :min="minCurRate" :max="maxCurRate" :interval="1" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.calculator_syntax.filter_year}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="creditYear" @keyup="keymonitor">
                            <svgIcon name="calendar" class="icon-calendar"/>
                        </div>
                        <div class="calculator-slider" v-if="!hideSlider">
                            <vue-slider v-model="creditYear" :min="minCreditYear" :max="maxCreditYear" :interval="1" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                </div>
                <!-- <div class="count-total-amount">
                    <a href="#" class="default-red-link" @click.prevent="totalAmountPrice">{{calculatorPage.calculator_syntax.btn_result}}</a>
                    <span class="error-msg" v-if="errorMsg">Заполните все поля</span>
                </div> -->
            </div>
            <div class="col-right">
                <div class="calculator-total-desc">
                    <div class="calculator-bank-head" v-if="currentBankSetup.logo != null">
                        <div class="bank-logo"><img :src="currentBankSetup.logo" alt=""></div>
                        <strong>{{ currentBankSetup.title }}</strong>
                    </div>
                    <div class="total-items-container">
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.calculator_syntax.result_month_pay}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{payPerMonth}} </p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.calculator_syntax.result_total_price}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{totalFlatPrice}}</p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.calculator_syntax.result_over_price}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{ovetBankAmount}}</p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calculator-total-links">
                    <!-- <div class="link-mail">
                        <a href="#" class="link-total" @click.prevent="formMailInit = true" :class="{'hide' : formMailInit}">{{ calculatorPage.by_btn_calc }}</a>
                        <formMailCalculator v-if="formMailInit" :options="[{price : price, initPrice: initPrice, pricePercent: pricePercent, curRate: curRate, creditYear: creditYear, payPerMonth: payPerMonth, totalFlatPrice: totalFlatPrice, ovetBankAmount: ovetBankAmount}]"></formMailCalculator>
                    </div> -->
                    <button class="link-total link-consult" @click="openContactsFormModal('call-page', 'hypothec-calculator', 'кнопка заказать консультацию')">
                        {{ calculatorPage.calculator_by_btn_var }}
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                </div>
            </div>
        </div>
        <div class="calculator-anounce-msg">
            <svgIcon name="alert" class="icon-alert"/>
            <p>{{ calculatorPage.calculator_syntax.calc_anounce_msg }}</p>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    // import formMailCalculator from '@/components/forms/form-mail-calculator.vue';
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'hypothec-calculator',
        components: {
            VueSlider,
            svgIcon,
            // formMailCalculator,
        },
        data () {
            return {
                hideSlider: false,
                formMailInit: false,
                // vars for slider
                minPrice: 1000000,
                maxPrice: 150000000,
                minInitPrice: 500000,
                maxInitPrice: 150000000,
                intervalPrice: 100000,
                interval: 500000,
                minCreditYear: 1,
                maxCreditYear: 30,
                minCurRate: 10,
                maxCurRate: 90,

                paymentMin: 10,
                // vars for calculator
                price: 25000000, //Стоимость квартиры
                initPrice: 7500000, // Первоначальный взнос
                pricePercent: 1, // Процент от стоимости квартиры в соотношение к первоначальному взносу
                curRate: 7, // Ставка кредита, % годо
                creditYear: 25, // Срок кредитования, годывых:
                // vars for total amount
                payPerMonth: null,
                totalFlatPrice: null,
                ovetBankAmount: null,
                // error var
                errorMsg: false,
                currentBankSetup: {
                    bank: null,
                    logo: null,
                    title: null,
                },
                swiperOption: {
                    speed: 1000,
                    observer: true,
                    observeParents: true,
                    effect: 'slide',
                    slidesPerView: 4,
                    spaceBetween: 15,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: false,
                    navigation: {
                        nextEl: '.bank-btn-next',
                        prevEl: '.bank-btn-prev',
                    },
                    breakpoints: {
                        1000: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        },
                    }
                },
            }
        },
        computed: mapGetters({
            calculatorPage: 'loadPaymentPage',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
            updateNumber() {
                // console.log('123123123');
                this.price = this.price.toLocaleString("en-US");
            },
            // splitNumber(price) {
            //     console.log('work')
            //     return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            // },
            keymonitor(event) {
                // console.log(event, 'asdasdasd')
                if (this.price > this.maxPrice) {
                    // this.price = this.maxPrice
                    // this.initPrice = Math.floor((this.price * this.minInitPrice) / 100);
                } 
                // else if (this.price < 1) {
                //     this.price = this.minPrice
                // }
                if (this.initPrice > this.maxInitPrice) {
                    // this.initPrice = this.maxInitPrice
                    this.pricePercent = 100
                } 
                // else if (this.initPrice < 1) {
                //     this.initPrice = this.minInitPrice;
                // }
                if (this.curRate > this.maxCurRate) {
                    // this.curRate = this.maxCurRate
                } 
                // else if (this.curRate < 1) {
                //     this.curRate = 1;
                // }
                if (this.creditYear > this.maxCreditYear) {
                    // this.creditYear = this.maxCreditYear
                } 
                // else if (this.creditYear < 1) {
                //     this.creditYear = 1;
                // }
                this.countPriceInitPercent();
                // this.totalAmountPrice();
            },
            buildDataForCalculator() {
                this.initPrice = Math.floor((this.price * 20) / 100);
            },
            countPriceInitPercent() {
                var precent = Math.floor((this.initPrice/this.price) * 100);
                // console.log(precent, this.paymentMin)
                if (precent < this.paymentMin) {
                    this.initPrice = Math.floor((this.price * this.paymentMin) / 100);
                    this.pricePercent = Math.floor((this.initPrice/this.price) * 100);
                } else if (precent > 90) {
                    this.pricePercent = 90;
                    this.initPrice = Math.floor((this.price * 90) / 100);
                } else {
                    this.pricePercent = precent;
                }
                this.totalAmountPrice();

                // if (precent > 0) {
                //     if (precent > 100) {
                //         this.pricePercent = 100;
                //     } else {
                //     }
                // } else {
                //     this.pricePercent = 0;
                // }
            },
            totalAmountPrice() {
                if (this.price > 0 && this.initPrice > 0 && this.curRate > 0 && this.creditYear > 0) {
                    this.errorMsg = false;
                    // Сумма кредитования 
                    var bankAmount = Number(this.price - this.initPrice);
                    // Ставка в месяц
                    var payMonth = Number((this.curRate / 12) / 100); 
                    // Коэффициент аннуитета
                    var koef = (payMonth * (Math.pow(1 + payMonth,  this.creditYear * 12))) / (Math.pow(1 + payMonth, this.creditYear * 12) - 1); 
                    // Ежемесячный платеж
                    var resultPayMonth = (bankAmount * koef).toFixed();
                    // Общая сумма займа с процентами
                    var totalBankAmount = resultPayMonth * (this.creditYear * 12);
                    // Сумма переплаты от суммы займа с процентами
                    var ovetBankAmount = totalBankAmount - bankAmount;
                    //Общая стоимость жилья с ипотекой
                    // console.log(totalBankAmount, this.initPrice);
                    var totalFlatPrice = Number(totalBankAmount) + Number(this.initPrice);

                    // var overPayment = Math.floor(bankAmount / (this.creditYear * this.curRate));
                    if (this.pricePercent < 100) {
                        this.payPerMonth = this.formatNumber(resultPayMonth);
                        this.totalFlatPrice = this.formatNumber(totalFlatPrice);
                        this.ovetBankAmount = this.formatNumber(ovetBankAmount);
                    } else {
                        this.payPerMonth = 0;
                        this.totalFlatPrice = this.formatNumber(this.price);
                        this.ovetBankAmount = 0;
                    }
                } else {
                    this.errorMsg = true;
                    // console.log('error')
                }
                // console.log(this.curRate)
            },
            setBankParams(item) {

                this.hideSlider = true;

                // console.log(item);
                this.currentBankSetup.logo = item.bank_logo;
                this.currentBankSetup.title = item.bank_title;
                this.currentBankSetup.bank = item.bank_name;
                // DATA FOR CALCULATOR
                // Параметры стоиомсти
                this.maxPrice = parseInt(item.bank_params.max_price);
                this.minPrice = parseInt(item.bank_params.min_price);
                this.price = parseInt(this.maxPrice/2);
                // Параметры первоначального взноса
                this.paymentMin = parseFloat(item.bank_params.payment_min);
                this.maxInitPrice = Math.floor((this.maxPrice * 90) / 100);
                this.minInitPrice = Math.floor((this.minPrice * parseFloat(item.bank_params.payment_min)) / 100);
                this.initPrice = Math.floor((this.price * parseFloat(item.bank_params.payment_min)) / 100);
                // console.log(this.initPrice, 'INIT PRICE')
                this.countPriceInitPercent();
                // Параметры процентная ставка %
                this.maxCurRate = parseInt(item.bank_params.credit_loan_max);
                this.minCurRate = parseInt(item.bank_params.credit_loan_min);
                this.curRate = parseInt(item.bank_params.credit_loan_min);
                // Параметры срок кредитования
                this.maxCreditYear = parseInt(item.bank_params.credit_time_max);
                this.minCreditYear = parseInt(item.bank_params.credit_time_min);
                this.creditYear = Math.floor(parseInt(item.bank_params.credit_time_max)/2);

                // console.log(this.price, this.maxPrice, this.maxInitPrice)

                setTimeout(() => {
                    this.hideSlider = false;
                }, 300);
                /// Запускаем расчет
                this.totalAmountPrice();
            },
            getConsultation() {
                // var data = {
                //     'city': this.currentCityArr[0].region,
                //     'page': this.options[0].data_page,
                //     'page_key': this.options[0].data_page_key,
                // }
                // this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            }
        },
        beforeCreate() {
            // document.body.dataset.page = 'hypothec-calculator';
        },
        created () {
            this.buildDataForCalculator();
            this.countPriceInitPercent();
            this.totalAmountPrice();
            this.setBankParams(this.calculatorPage.calculator_banks_params[0])
            // document.title = this.title;
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/payment-page/hypothec-calculator.scss';
    @import '@/styles/components/payment-page/respond/hypothec-calculator-respond.scss';
    // @import '@/styles/respond/hypothec-calculator/hypothec-calculator-respond.scss';
</style>